const AnalyticsAPIURL = {

    AddTrackPage: "api/Analytics/AddTrackPage",
}
export default AnalyticsAPIURL;